import { AxiosResponse } from 'axios';
import api from '../../services/api';
import { Pair, PairListResponse } from '../../types/pair';

export const pairApi = {
  // Get last N pair records
  getLastPairRecords: async (limit: number = 5, includeRelatedPairs: boolean = false, orderBy: 'id' | 'createdAt' = 'createdAt'): Promise<PairListResponse> => {
    const params = new URLSearchParams({
      limit: limit.toString(),
      includeRelatedPairs: includeRelatedPairs.toString(),
      orderBy: orderBy,
    });
    const response: AxiosResponse<PairListResponse> = await api.get(`/pair?${params.toString()}`);
    return response.data;
  },

  // Get pair record by ID
  getPairRecordById: async (id: number): Promise<Pair> => {
    const response: AxiosResponse<Pair> = await api.get(`/pair/${id}`);
    return response.data;
  },

  // Get pair statistics
  getStats: async (): Promise<any> => {
    const response: AxiosResponse<any> = await api.get('/pair/stats');
    return response.data;
  }
};
